import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const RoleApi = createApi({
  reducerPath: "RoleApi",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    //Start Role API's--------------------------------------------
    getAllRoleData: builder.query({
      query: () => "get_all_roles",
      transformResponse: (response) => response?.data || [],
    }),
    getRoleById: builder.query({
      query: ({ id }) => `get_single_role/${id}`,
      transformResponse: (response) => response?.data || [],
    }),
    addRole: builder.mutation({
      query: (addRole) => ({
        url: "add_role",
        method: "POST",
        body: addRole,
      }),
    }),

    editRole: builder.mutation({
      query: (editRole) => ({
        url: `update_role`,
        method: "PUT",
        body: editRole,
      }),
    }),
    //END Role API's--------------------------------------------
  }),
});

export const {
  //Role api
  useGetAllRoleDataQuery,
  useGetRoleByIdQuery,
  useAddRoleMutation,
  useEditRoleMutation,
} = RoleApi;

export default RoleApi;
